enum AlertSeverity {
  ERROR = 'error',
  SUCCESS = 'success',
  INFO = 'info'
}

export default AlertSeverity;
